module.exports = __webpack_public_path__ + "media/music/piano_4-54b96dda.mp3";